import { Struct } from 'shoteyes-types';
import { Checkbox, Col, Row, Space } from 'antd';
import { Block } from '../../../block';
import styles from '../style.module.less';
import { service } from '../service';
import { SelectStyleEnum } from '../types';
import type { ReactElement } from 'react';
import type { CheckBoxProps } from './types';

export function CheckBoxComponent(props: CheckBoxProps): ReactElement {
  const { max, value } = props;

  const onChange = (values: string[]): void => {
    if (max != null && values.length > max) {
      return;
    }

    props.onPropsChange?.({ value: values });
  };

  // 考试单独特殊显示
  if (props?.formType === Struct.FormType.ANSWER) {
    return (
      <div className={styles.mb10}> {
        (props?.option ?? [])?.map((row, index) => (
          <Row key={index}>
            <Col span={12} key={`${row.value}_${row.title}`}>
              <div>{row.value}.{row.title}</div>
            </Col>
          </Row>
        ))}
      </div>
    );
  }

  return (
    <Checkbox.Group value={value} className={styles.radioGroup} onChange={onChange}>
      <Block if={props.selectStyle === SelectStyleEnum.GRID}>
        {service.splitArray((props.option ?? []), 2).map((row, index) => (<Row key={index}>
          {
            row.map(col => (
              <Col span={12} key={`${col.value}_${col.title}`}>
                <Checkbox value={col.value}>{col.title}</Checkbox>
              </Col>
            ))
          }
        </Row>))}
      </Block>
      <Block if={[SelectStyleEnum.LINE, SelectStyleEnum.LIST].includes(props.selectStyle)}>
        <Space direction={props.selectStyle === SelectStyleEnum.LIST ? 'vertical' : 'horizontal'} wrap>
          {(props.option ?? []).map(item => (
            <Checkbox value={item.value} key={`${item.title}_${item.value}`}>
              {item.title}
            </Checkbox>
          ))}
        </Space>
      </Block>
      <Block if={props.selectStyle == null}>
        <Space direction='horizontal' wrap>
          {(props.option ?? []).map(item => (
            <Checkbox value={item.value} key={`${item.title}_${item.value}`}>
              {item.title}
            </Checkbox>
          ))}
        </Space>
      </Block>
    </Checkbox.Group>
  );
}
